import React from 'react';
import { LinearProgress, Box, Typography } from '@mui/material';

function LinearProgressWithLabel(props) {
  return (
    <Box sx={{ display: 'flex', alignItems: 'center' }}>
      <Box sx={{ width: '100%', mr: 1 }}>
        <LinearProgress variant="determinate" {...props} />
      </Box>
      <Box sx={{ minWidth: 35 }}>
        <Typography variant="body2" color="text.secondary">
          {`${Math.round(props.value)}%`}
        </Typography>
      </Box>
    </Box>
  );
}

const ProgressBar = ({ sessions }) => {
  const totalSessions = sessions.length;
  const completedSessions = sessions.filter(session => new Date(session.date_from) < new Date()).length;
  const progress = (completedSessions / totalSessions) * 100;

  return (
    <Box sx={{ width: '100%' }}>
      <LinearProgressWithLabel sx={{ height: '20px', borderRadius: '4px', m: 2 }} variant="determinate" value={progress} />
    </Box>
  );
};

export default ProgressBar;
